import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import ChiSiamo from "./components/ChiSiamo";
import Servizi from "./components/Servizi";
import Formazioni from "./components/Formazioni";
import Generi from "./components/Generi";
import Gallery from "./components/Gallery";
import Testimonials from "./components/Testimonials";
import FaqSection from "./components/FaqSection";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

const Home = () => {
  useEffect(() => {
    document.documentElement.classList.add("dark");
    document.body.classList.add("grain");
  }, []);

  return (
    <main className="bg-pw text-[var(--pw-text)]" data-testid="home-page">
      <Navbar />
      <Hero />
      <ChiSiamo />
      <Servizi />
      <Formazioni />
      <Generi />
      <Gallery />
      <Testimonials />
      <FaqSection />
      <Contact />
      <Footer />
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#121212",
            border: "1px solid rgba(212,175,55,0.3)",
            color: "#f8f5f0",
            fontFamily: "'Outfit', sans-serif",
          },
        }}
      />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
